import React, {Component} from "react";
import {CircularProgress,Button } from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {SaveAltTwoTone} from "@material-ui/icons";
import ReactTable from "react-table";
import { ReactTableDefaults } from "react-table";
import ReportService from "../../services/ReportService";
import {columns, usrColumns} from "./tblColumns";
import Ability from "../../config/Ability";
import ReactExport from "react-data-export";
import classNames from "classnames";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const reportService = new ReportService();

Object.assign(ReactTableDefaults, {
    minRows: 5
});

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 4,
        paddingBottom: theme.spacing.unit * 2,
        flexGrow: 1,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
        height: "85vh",
        overflow: "auto",
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    wrapper: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
        height: "85vh",
        overflow: "auto",
    },
    // buttonSuccess: {
    //     backgroundColor: green[500],
    //     '&:hover': {
    //         backgroundColor: green[700],
    //     },
    // },
    // buttonProgress: {
    //     color: green[500],
    //     position: 'absolute',
    //     top: '5%',
    //     left: '3%',
    //     marginTop: -12,
    //     marginLeft: -12,
    // },
    button: {
        marginTop: theme.spacing.unit,
        marginBottom : theme.spacing.unit,
    },
});

const requestData = (pageSize, page, sorted, filtered) => {
    return new Promise((resolve, reject) => {
        reportService.allTransactionReport({
            pageSize:pageSize,
            page:page,
            sorted:sorted,
            filtered:filtered
        },(err,data)=>{
            if (err) {
                const res = {
                    rows: [],
                    pages: 0
                };
                return resolve(res);
            }else{
                let filteredData = data.results;
                const res = {
                    rows: filteredData,
                    pages: data.pages
                };
                return resolve(res);
            } 
        });
    });
};

class TransactionLayout extends Component {
    _isMounted = false;
    constructor() {
        super();
        this.state = {
            data: [],
            pages: null,
            loading: true
        };
        this.fetchData = this.fetchData.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchData(state, instance) {
        this.setState({ loading: true });
        requestData(
            state.pageSize,
            state.page,
            state.sorted,
            state.filtered
        ).then(res => {
            if (this._isMounted) {
                this.setState({
                    data: res.rows,
                    pages: res.pages,
                    loading: false
                });
            }
        });
    }

    render() {

        const {classes} = this.props;  

        return (
        // <Paper className={classes.root}>

            <div className={classes.wrapper}>
                <ExcelFile element={
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={this.state.loading}
                        className={classes.button}
                        size="small"
                    >
                        <SaveAltTwoTone className={classNames(classes.leftIcon, classes.iconSmall)}/>
                                Export
                    </Button>
                }
                filename = {"report_directpay_transaction"}
                >
                    <ExcelSheet data={this.state.data} name="Employees">
                        <ExcelColumn label="Reference" value="id"/>
                        <ExcelColumn label="Date/Time" value="dateTime"/>
                        <ExcelColumn label="Merchant Name" value="payeeUserName"/>
                        <ExcelColumn label="Type" value="type"/>
                        <ExcelColumn label="Category" value="paymentCategory"/>
                        <ExcelColumn label="Response" value="status"/>
                        <ExcelColumn label="Description" value="castomParam"/>
                        <ExcelColumn label="Amount(Rs.)" value="originalAmount"/>
                    </ExcelSheet>
                </ExcelFile>
                {/* {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />} */}

                <ReactTable
                    columns={Ability.can("view", "/account/intigration") ? columns : usrColumns}
                    className="-striped -highlight"
                    data={this.state.data}
                    loading={this.state.loading}
                    pages={this.state.pages}
                    defaultPageSize={20}
                    manual
                    onFetchData={this.fetchData}
                    showPageJump={false}
                    loadingText= {<CircularProgress size={30} thickness={5} />}
                    noDataText = {"No transaction available"}
                    filterable
                    style={{
                        height: "600px"
                    }}
                    defaultSorted={[
                        {
                            id: "id",
                            desc: true
                
                        }
                    ]}
                    //     SubComponent={row => {
                    //         //console.log(row);
                    //         return (                   
                    //         <ReactTable
                    //         columns={[
                    //             {
                    //                 Header: 'Type',
                    //                 style: {textAlign:'center'},
                    //             },
                    //             {
                    //                 Header: 'Value',
                    //                 style: {textAlign:'center'}
                    //             }                          
                    //         ]}
                    //         className="-striped -highlight"
                    //         data={this.state.data}
                    //         showPagination={false}
                    //         />
                    //         )
                    //     }                  
                    // }
                />

            </div>
        );
    }
}

TransactionLayout.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TransactionLayout);